import * as types from 'store/modules/hrms6ae/mutation-types'
import hrms6ae from 'api/hrms6ae'
import swal from 'sweetalert'
import hrms6aeLabels from 'assets/labels/hrms6ae'
import { hrms6aeMaxRowspan, hrms6aeColumns } from 'assets/columns/hrms6ae'
import configLabel from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hrms6aeLabels,
    maxRowspan: hrms6aeMaxRowspan,
    columns: hrms6aeColumns(),
    index: {
      total: 0,
      rows: []
    },
    currentNumseq: 0,
    indexSelected: {},
    detail: {
      table: {
        total: 0,
        rows: []
      },
      popup: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      }
    },
    saveButtonDisp: true
  },
  getters: {
    [types.GET_HRMS6AE_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS6AE_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRMS6AE_MAX_ROWSPAN] (state) {
      return state.maxRowspan
    },
    [types.GET_HRMS6AE_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS6AE_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS6AE_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS6AE_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRMS6AE_CURRENT_NUMSEQ] (state) {
      return state.currentNumseq
    },
    [types.GET_HRMS6AE_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRMS6AE_DETAIL_SEARCH] (state) {
      return state.detail
    },
    [types.GET_HRMS6AE_SAVE_BUTTON_DISP] (state) {
      return state.saveButtonDisp
    }
  },
  mutations: {
    [types.SET_HRMS6AE_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS6AE_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRMS6AE_COLUMNS] (state, { labels, dropdowns }) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        let dropdownSets = [{ key: 'codreqst', value: dropdowns.codreqst[keyLang] }]
        state.columns[keyLang].detail = configLabel.replaceLabelToColumns(state.columns[keyLang].detail, labels[keyLang], dropdownSets)
        state.columns[keyLang].detailPopup = configLabel.replaceLabelToColumns(state.columns[keyLang].detailPopup, labels[keyLang])
      }
    },
    [types.SET_HRMS6AE_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRMS6AE_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRMS6AE_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRMS6AE_CURRENT_NUMSEQ] (state, data) {
      state.currentNumseq = data
    },
    [types.SET_HRMS6AE_DETAIL] (state, data) {
      state.detail = data
    },
    [types.SET_HRMS6AE_DETAIL_SEARCH] (state, data) {
      state.detail = data // use same SET_HRMS6AE_DETAIL
    },
    [types.SET_HRMS6AE_SAVE_BUTTON_DISP] (state, saveButtonDisp) {
      state.saveButtonDisp = saveButtonDisp
    }
  },
  actions: {
    [types.TOGGLE_HRMS6AE_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRMS6AE_INDEX_DISP, indexDisp)
      commit(types.SET_HRMS6AE_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRMS6AE_COLUMNS_LABELS] ({ commit }) {
      hrms6ae.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS6AE_COLUMNS, { labels: data.labels, dropdowns: data.dropdowns })
          commit(types.SET_HRMS6AE_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS6AE_INDEX] ({ commit }, searchParams) {
      hrms6ae.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS6AE_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS6AE_INDEX, objData)
        })
    },
    [types.RECEIVED_HRMS6AE_CURRENT_NUMSEQ] ({ commit }, currentNumseq) {
      if (typeof currentNumseq === 'undefined') {
        hrms6ae.getCurrentNumseq()
          .then((response) => {
            const data = JSON.parse(response.request.response)
            commit(types.SET_HRMS6AE_CURRENT_NUMSEQ, data)
            commit(types.SET_HRMS6AE_DETAIL, {})
          })
          .catch((error) => {
            let message = error
            if (error.response) {
              const data = error.response.data
              message = data.response
            }
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          })
      } else {
        commit(types.SET_HRMS6AE_CURRENT_NUMSEQ, currentNumseq)
      }
    },
    [types.RECEIVED_HRMS6AE_DETAIL] ({ commit }, searchParams) {
      hrms6ae.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS6AE_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS6AE_DETAIL_SEARCH] ({ commit }, searchDetail) {
      hrms6ae.getDetailSearch(searchDetail)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS6AE_DETAIL_SEARCH, data)
          commit(types.SET_HRMS6AE_SAVE_BUTTON_DISP, true)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let emptyData = {
            table: {
              total: 0,
              rows: []
            },
            popup: {
              detail: {},
              table: {
                total: 0,
                rows: []
              }
            }
          }
          commit(types.SET_HRMS6AE_DETAIL_SEARCH, emptyData)
        })
    },
    [types.POST_HRMS6AE_SAVE] ({ commit, dispatch }, { dataRowsHasFlg, searchIndex, searchDetail }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel'),
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms6ae.postSave(dataRowsHasFlg)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS6AE_INDEX, searchIndex)
              dispatch(types.RECEIVED_HRMS6AE_DETAIL_SEARCH, searchDetail)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS6AE_CANCEL] ({ commit, dispatch }, { cancelParams, searchParams }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmCancel'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel'),
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms6ae.postCancel(cancelParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS6AE_INDEX, searchParams)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms6ae/index.js